// src/components/scan/ScanHistory/ScanHistoryDesktop.tsx
import React from 'react';
import { Calendar, Clock, History } from 'lucide-react';

export interface ScanHistoryProps {
  scanHistory: {
    domain?: string;
    lastScanDate?: string;
    scansLastYear?: number;
  } | null;
  t: (key: string) => string;
}

const formatDate = (dateString?: string) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

const ScanHistoryDesktop: React.FC<ScanHistoryProps> = ({ scanHistory, t }) => {
  if (!scanHistory) return null;

  return (
    <div className="bg-gray-900 p-6 rounded-xl shadow-lg border border-gray-700 mb-8">
      <div className="text-center text-white mb-6">
        <h2 className="text-2xl font-bold flex items-center justify-center gap-2">
          <History className="w-6 h-6 text-blue-500" />
          {t('scan.history_title')} {scanHistory.domain ?? ''}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-white">
        <div className="bg-gray-800 p-4 rounded-lg shadow-md flex flex-col items-center">
          <Calendar className="w-6 h-6 text-blue-500 mb-2" />
          <h3 className="text-lg font-semibold">{t('scan.lastScan')}</h3>
          <p className="text-gray-300 text-lg">{formatDate(scanHistory.lastScanDate)}</p>
        </div>

        <div className="bg-gray-800 p-4 rounded-lg shadow-md flex flex-col items-center">
          <Clock className="w-6 h-6 text-blue-500 mb-2" />
          <h3 className="text-lg font-semibold">{t('scan.scansLastYear')}</h3>
          <p className="text-gray-300 text-lg">{scanHistory.scansLastYear ?? '—'}</p>
        </div>
      </div>
    </div>
  );
};

export default ScanHistoryDesktop;
